// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2OTyA","buttons":"Footer_buttons__3n2LR"};